// Libarary
import { Injectable } from '@angular/core';
import pdfMake from 'pdfmake/build/pdfmake';
// Service
import { ConfigService } from '../infrastructure/config.service';
import { NetworkService } from '../infrastructure/network.service';
import { LoaderService } from '../infrastructure/loader.service';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../common/common.service';


@Injectable({
  providedIn: 'root'
})
export class CppProductlabel {
  pdfDataObject: any;
  basePdfData: string;
  constructor(public configService: ConfigService,
    private networkService: NetworkService,
    private loaderService: LoaderService,
    private toastrService: ToastrService,
    private commonService: CommonService,
    private datePipe: DatePipe) {
  }

  // get Product Label Account List

  public getProductLabelAccountList() {
    return this.networkService.getRequest(this.configService.getProductLabelAccountListUrl());
  }

  //get Product Label Items List

  public getProductLabelItemsList() {
    return this.networkService.getRequest(this.configService.getProductLabelItemsListUrl());
  }

  // cpp Save Product Label Order

  public cppSaveProductLabelOrder(data) {
    return this.networkService.postRequest(this.configService.cppSaveProductLabelOrderUrl(), data);
  }

  // Get Product Label Orders
  public getProductLabelOrders(filters) {
    return this.networkService.postRequest(this.configService.getProductLabelOrdersData(), filters);
  }

  // Get Product label order details
  public getProductLabelOrderDetail(orderNumber) {
    return this.networkService.getRequest(this.configService.getProductLabelOrderDetails() + '?orderNumber=' + orderNumber);
  }

  // Get Unauthorized Product Warning Message
  public getUnauthorizedProductWarningMessage() {
    return this.networkService.getRequest(this.configService.getUnauthorizedProductWarningMessageUrl());
  }

  public generatePdf(orderNumber) {
    if (orderNumber) {
      this.loaderService.setLoaderStatus(true);
      this.getProductLabelOrderDetail(orderNumber).subscribe((result) => {
        if (result) {
          if (result !== undefined && result.productLabelItems.length > 0) {
            this.pdfDataObject = result;
            const documentDefinition = this.getDocumentDefinition();
            pdfMake.createPdf(documentDefinition).download('Product Label Orders_' + result.orderNumber + '_' + this.commonService.GetTimeForFileName() + '.pdf');
          } else {
            this.toastrService.error('No data available for Order Number #' + result.orderNumber);
          }
          this.loaderService.setLoaderStatus(false);
        }
      }, error => {
        this.loaderService.setLoaderStatus(false);
      });
    }
  }

  getDocumentDefinition() {
    const orderCreateDate = this.datePipe.transform(this.pdfDataObject.orderDate, 'MMMM dd, yyyy');
    //const createDateTime = this.pdfDataObject.createdOnString;

    let displayWith = [];
    let columnList = [];
    let valueList = [];

    // ShipTo Account available
    displayWith = ['50%', '50%'];
    columnList = [{ text: 'Date Ordered: ', bold: true }, { text: 'Account # :' + this.pdfDataObject.accountNumber, bold: true }];
    valueList = [
       this.datePipe.transform(this.pdfDataObject.orderDate, 'MM/dd/yyyy') + ' \n' + ' \n' + ' \n' +
      'Ordered By: ' + '\n' + this.pdfDataObject.orderBy + ' \n' + ' \n',

      'Account:' + '\n' +
      this.pdfDataObject.accountName + '\n' +
      this.pdfDataObject.address + '\n' +
      this.pdfDataObject.city + '\n' + this.pdfDataObject.state + ' ' + this.pdfDataObject.zipCode + '\n'
      //'Attn: ' + this.pdfDataObject.attn + '\n' +
      //this.pdfDataObject.email
    ];

    const pdfHTML = {
      footer: function (currentPage, pageCount, pageSize) {
        return [
          { text: orderCreateDate, alignment: 'left', fontSize: 8, style: 'pageText', marginLeft: 45 },
          { text: 'Page' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'pageText', fontSize: 8, marginRight: 45 },
        ];
      },
      content: [
        {
          style: 'pageText',
          widths: ['25%', '50%', '25%'],
          marginTop: 10,
          fontSize: 8,
          bold: true,
          columns: [{
            image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAAAlCAYAAACwE5ygAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpjZjgzMmU0Yy1kODcyLTQ3YWQtYmU4NC1mMDc4YTMzYTMwNTgiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MDEwRjZDNEM3MzAxMTFFOUE0RkRDODkwMzhGMUZGM0QiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MDEwRjZDNEI3MzAxMTFFOUE0RkRDODkwMzhGMUZGM0QiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpjZjgzMmU0Yy1kODcyLTQ3YWQtYmU4NC1mMDc4YTMzYTMwNTgiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6Y2Y4MzJlNGMtZDg3Mi00N2FkLWJlODQtZjA3OGEzM2EzMDU4Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+NCs+0wAACJ5JREFUeNrsW3lsFFUYf3u05bBUCwUULCglWokU5RARhQJRIeCBCigIMSEgiglWRMAjiMQjeP6l4oWAiHJIRDksp4CAUkWg4AHlaCl35VxaaLd+X/p72a/PmdnZ2nYh2S/5Zd++mfdm5n3392Y89bs9OF8pdaOqoJGEVaoyzSZ0JHgI3xKyjONjCKPRnkcYr6qf+hLeIZTiv8fhXB/hb0IfdQmTn7CV0B//exuMuYbwsPj/NGEioVj0DSS0QntHDd1nU0JaBOenqUucmDGvYbHjCQMI48TxWy3GXCsY0IjQHu09hBloTyJcQQigXUJIFdpWTviYkGsx/wuExoRCwuvoC4jjywiLoRlWxNp0HG2eZwLO/Y3wGfrvI2QSgg5rw/OcIEzGeTcQRqB/A2GOi/UdD6Eqt5i7DM+4RKxnS8Jwwh8eMmXcsZ7QBQdvI/yE9lTCWGPSUYQPhAa9jfaHhMcJXlxU0+WEk4TuhjZyX2e+CWP+cvHrRfsRwhdos/DMdSl4GYQtaOcQOqD9FeZxQ3EwoYMIX6Ivm3Cni7HBMGZXifvh+ZsQdhPW+nHgE8GYTmCMR9z8IkIDQjfCYMGYTmLy+UIaDhCaEU4LqQwYN5MEgWiL85XQPDahf9o8RD9Ckc2xddBOTbK9T7QLRXsFrukVAhEHFIn7Py3GFLhkKj/D9YQz8M/lQlsS4Tv9cAes3T1gsXZrxszAYsfhwd8ltIP5UTAH6WBMVzxEEG29mNlVMKXJEIJ0C8bZ0aOAFTFD90Z4D1nwszVJhRBoK1/IZrk1TOtzhDeUkBJW1U1o98DvleIY+4LNYsJ6WITm+L8kwht9C2ZSgfk/G6bDiUoRfJg4SzhfhUXjSHItnp/xCyS4OsnumXYRHhP/h+qGV3R+KtptwUWmPPweFscz4TNMM+aWzkBltZa1gUPV2udEb0LtTbAgHazCorWG5ncCOgizXhskI9kEGZUpYc5YihsSpggztg6/59DuimhD22/WppUR3owOZ9mBbiTcgkBgPXyPE/1j2Pv/S1OgMT4h3evCjDkX4TXKHI71s5rXbwxeDjWWJ88U7c/BGClRs6qwGOeNkDwXfsaNpNarZollJvxg9CUgePEi9Db9HwtvCpjoMcJgNrWHjPM5FbkKftmH52f/OsyIel+xYgzT94Z9PUZYLf4vIHxkjFlu8bB1jF/TbMYZ4TFryzahpZXU2shZ/BEsusdYHKvrL3URbMwy7mGggx86grBXPkOqEXna+d2vrRZLIU4/Jf6b5Zki4XMUcpDNDoyREuW1WSSFa7Y3wtA6NoyJi4AxXheMcauhXpfnN7Z5Biu6AMEebuaLOsGUlAp4UHMy1bIVHC0f3wmtMqU0A3F6AAkem8nLUJPjRcm3cfINMDYIP7JVmI50LM5uF9InFyYDv4V4Hv2MLYw8x4ri8YzHkSi3gakqd6ikBERS2xbrcMFCYIII7Y9YqroFY2J0kdTKJBd9kIYyG6nwQPp8yB1K0ZcgVD3gIH3xGFOC+WVfsXEfQRf+Q9+rF/dV7iDNeu4SjPHhvoMW8wZdaFONktfID/ajdJHhEObmwxdkicrvXvTno+5jRdMwbi9Mk/Zp3Pe7uJcFMFUaBbinfWgXCqzBmJvE9Q/A/B40cAjoIwqZBRZjDmHuPITvI6KtMS2wyEz1HaReL2qKmKOJOGcAbOoQY2xz5ChJ4rotRJ+W9DtQmXZDKSL6SY7QOSeFuU4yqhtdEJn1RmJc64w5aUQL4RKls6KCWmZEToMRaT1hMX+ZMB8nRFgeh/j+fiyePo/rc2Nw3mwkwn6YnNMWERdXoZ83rEFdLLJHRJFyT0nOG8TYq1EjTEXuxjncA9FgTHXQj5BijqBG4SFHu7yWZuwai0xfM4bLNsvC1KJ8uFaCMNfHlPMmnt28XGrKAZP6w5Tvqm0fIylYxflWIpPX0vgkpE4vsBPZOe1mot3Ixf0OwuLlAtuM3MuK7OY9qirv/fSKhsZIqSu2Of+4TdKn6WYV2hTbiL5XVUXF9mgtPVMA9+ARUdavVRQKnVtF1fnLhW5J2G5xfjubcofpg7h83lNVbEIxZRsVhZqk91TFVnkkdMym/24jiFkcDcZwnUa/eMH78ZNQ3DuKaI0rwVPF+TlhJI/NGu/QfVfLktcLQhBvPGciTDeXmRYaY4bAZNaFWSyH9mcataz90WDMQuQyYxH+vu8wjs3TN2IOnwiJzaLoUBV6SUM6Zx0uaxtvtzeeZBEemyTD+46AHWXgWRNFX2fAjrjq+1K0TBnTs5Coe5BPpBsFSzZJSw2V5pB1HmphVvsyM7EIvWHqLohQexaChYMq9M6YSduhdT5EfVbESeuiMHUsXTubh3Yu5j1vkfn7UMPaiSRzU237mHC1smQs6hnD8ccoynlMkbJ/IyVGUchjYnQRaUxTmC2fcMRsuyPd385EuD09jL2PkUsfk22R2XZRobdX3NJh1Lo8seWtHo3RL4b3FGFtHmpOJcaYBERWPuQnJ0VZ5Aiin/oYV2pERXovJlGF3naMkYOP0RtPKwHWoBNYdP1KLFdo85Gv3I5QuQi/D4nsv0CFXgzXr9G+qCrqZX7kBKcQ6a2KaZczY/KwQAEgB9LNjBiJc4bDFxUiweRMmN8k5M2l2TjnLLRhDxJCXRl+Cj6L+15WFS/88ftk3VXFazwxsmFMHeFrVoik6hmRXfNu3hZoSEOUbqajSqDNYrHI1rmQOQgmKwUJrC6W8h6H3hK4LsYKex+TClN2r3GOzrbnoHQyzCivKPXf14F0/wSYKv0JBb+qo79eS4CZHInsOkY2jNGfCMh3mCfD/LDk90XfGuFLshCFTRRlljQVql2thvNn/7MD2qR3R9nU8cuD/CHUgRgr7E0Zf7+xHT5DQ++Ps7Pmbz3mCgbcBR80DQGA/pBnkxFi87c3f4HJCqZwHEzcBghCWowVlelfAQYAh1IXcqAQJnwAAAAASUVORK5CYII=',
            width: 60,
            height: 20,
            alignment: 'left',
            fit: [100, 100]
          },
          {
            text: orderCreateDate, alignment: 'right', fontSize: 15, style: 'pageText', marginRight: 30
          }]
        },
        {
          style: 'headername',
          table: {
            body: [
              [
                'Your label order has been created!'
              ],
            ]
          },
          fontSize: 18,
          layout: 'noBorders',
          marginTop: 10
        },
        {
          layout: 'noBorders',
          table: {
            body: [
              ['\n Dear ' + this.pdfDataObject.createUser + ',']
            ]
          },
          style: 'pageText',
          fontSize: 8,
          marginTop: 10
        },
        {
          text: [
            'A new label order has been created for you. Please review the label order information below to ensure accuracy.',
          ],
          style: 'pageText',
          fontSize: 8,
          marginTop: 10
        },
        {
          table: {
            widths: displayWith,
            headerRows: 1,
            fontSize: 10,
            body: [
              columnList,
              valueList,
            ]
          },
          marginTop: 10,
          fontSize: 8,
          style: 'tableHeader',
          layout: {
            hLineColor: function (i, node) {
              // Remove bottom border for the first row
              if (i === 1) {
                return null; // No line
              }
              return '#b0b0b0'; // Gray color for other horizontal lines
            },
            vLineColor: function (i, node) {
              return '#b0b0b0'; // Gray color for vertical lines
            },
            hLineWidth: function (i, node) {
              return i === 1 ? 0 : 1; // Thickness of horizontal lines
            },
            vLineWidth: function (i, node) {
              return 1; // Thickness of vertical lines
            },
            paddingLeft: function (i, node) {
              return 4; // Left padding
            },
            paddingRight: function (i, node) {
              return 4; // Right padding
            },
            paddingTop: function (i, node) {
              return 2; // Top padding
            },
            paddingBottom: function (i, node) {
              return 2; // Bottom padding
            },
          }
        },
        {
          text: [
            { text: 'Order: ', bold: true },
             this.pdfDataObject.orderNumber ,
          ],
          style: 'pageText',
          fontSize: 10,
          marginTop: 10
        },
        this.getContractPdfObject(this.pdfDataObject.productLabelItems),
        {
          style: 'tablefont',
          table: {
            body: [
              ['\n*Actual shipped units may vary' + '\n' + '\n' +
                 ' If you have questions regarding these changes, please contact Winfield United Customer Service #855-494-6343.'],
            ]
          },
          layout: 'noBorders',
          marginTop: 20
        },
      ],
      styles: {
        pageText: {
          color: '#0b3f54',
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 20, 0, 10],
          decoration: 'underline'
        },
        name: {
          fontSize: 16,
          bold: true
        },
        jobTitle: {
          fontSize: 14,
          bold: true,
          italics: true
        },
        sign: {
          margin: [0, 50, 0, 10],
          alignment: 'right',
          italics: true
        },
        headername: {
          fontSize: 18,
          bold: true,
          color: '#0b3f54'
        },
        tableHeader: {
          bold: true,
          fillColor: '#F5F6FA',
          fontSize: 8,
          color: '#0b3f54',
          border: [true, true, true, true],
        },
        tablefont: {
          fontSize: 8,
          color: '#0b3f54'
        },
      }
    };

    return pdfHTML;
  }

  // Grid display for each split in PDF
  getContractPdfObject(failedProductList) {
    const tblObject = [];
    const requestDetails = failedProductList;
    const tbl = {
      layout: {
        hLineWidth: function (i, node) {
          return (i === 0 ? 0 : (i === 1 ? 0.5 : 1)); // No borders on the first or last row
        },
        vLineWidth: function (i, node) {         
          return (i === 1) ? 0 : 0.5; // No vertical borders between columns (middle)
        },
        hLineColor: function (i, node) {
          return '#b0b0b0'; // Gray color for other horizontal lines
        },
        vLineColor: function (i, node) {
          return '#b0b0b0'; // Gray color for vertical lines
        },
        paddingLeft: function () { return 10; }, // Add padding on the left
        paddingRight: function () { return 10; }, // Add padding on the right
        paddingTop: function () { return 5; }, // Add padding on top
        paddingBottom: function () { return 5; } // Add padding at the bottom
      },
      table: {
        widths: ['65%', '35%'],
        color: '#0b3f54',
        body: [
          [{
            text: 'Product',
            style: 'tableHeader', margin: [10, 5, 0, 5], border: [false, false, false, false], fontSize: 10
          },
          {
            text: 'Ordered Qty*',
            style: 'tableHeader', alignment: 'center', margin: [0, 5, 0, 5], border: [false, false, false, false], fontSize: 10
          }
          ],
          ...requestDetails.map(cl => [
            { text: cl.product, margin: [10, 5, 0, 5], bold: true, fontSize: 9 }, // Add padding
            { text: cl.quantity, alignment: 'center', margin: [0, 5, 0, 5], bold: true, fontSize: 9 } // Add padding
          ])
        ]
      },
      style: 'tablefont',
      marginTop: 5,
    };
    tblObject.push(tbl);
    return tblObject;
  }

}
